import React from 'react';
import Type from 'prop-types';
import { Link as RouterLink, useRouteMatch } from 'react-router-dom';
import { Card, CardContent, Box, Link, Typography, Grid } from '@material-ui/core';
import { Amount } from 'components';
import { ru } from 'locale';
import useStyles from './LoanBorrower.styles';

const LoanBorrower = props => {
  const { borrower, screen } = props;
  const { path } = useRouteMatch();
  const classes = useStyles();
  const isRenderWithLink = screen === 'main';
  let textTerm = ru.term;
  let textAmount = ru.amount;
  switch (screen) {
    case 'decision':
      textTerm = ru.requestedTerm;
      textAmount = ru.requestedAmount;
      break;

    case 'main':
    default:
      textTerm = ru.term;
      textAmount = ru.amount;
      break;
  }

  const renderCardContent = () => (
    <CardContent className={classes.content} id="loan-borrower">
      <Box m={2}>
        <Typography
          color="textSecondary"
          variant="overline"
          align="center"
          component="p"
          gutterBottom
        >
          {ru.requestedConditions}
        </Typography>
      </Box>

      <Grid container align="center" className={classes.row}>
        <Grid item xs={6}>
          <Box m={2}>
            <Typography color="textSecondary" component="div" variant="body2">
              {textTerm}
            </Typography>
            <Typography color="textPrimary" component="div" variant="h6">
              {`${borrower.term} ${ru.shortDays}`}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={6} className={classes.rightCol}>
          <Box m={2}>
            <Typography color="textSecondary" component="div" variant="body2">
              {textAmount}
            </Typography>
            <Amount
              amount={{ value: borrower.value, currency: { code: 'RUR', minority: 0 } }}
              className={classes.amount}
              variant="h6"
            />
          </Box>
        </Grid>
      </Grid>
    </CardContent>
  );

  const renderWithLink = () => (
    <Link component={RouterLink} to={`${path}/decisions`}>
      {renderCardContent()}
    </Link>
  );

  return <Card square>{isRenderWithLink ? renderWithLink() : renderCardContent()}</Card>;
};

LoanBorrower.propTypes = {
  borrower: Type.shape({
    term: Type.number.isRequired,
    value: Type.number.isRequired,
  }).isRequired,
  screen: Type.oneOf(['decision', 'main']).isRequired,
};

export default LoanBorrower;
